/**
 * @file en.ts
 * @description English translations for PaymentErrorBoundary (Task 33.1)
 */

export interface PaymentErrorTranslations {
  ENTRY_FEE_PAYMENT_REQUIRED: { title: string; description: string };
  ENTRY_FEE_PAYMENT_PENDING: { title: string; description: string };
  ENTRY_FEE_PAYMENT_EXPIRED: { title: string; description: string };
  ENTRY_FEE_PAYMENT_MISMATCH: { title: string; description: string };
  PAYMENT_OWNER_MISMATCH: { title: string; description: string };
  NETWORK_ERROR: { title: string; description: string };
  TIMEOUT_ERROR: { title: string; description: string };
  UNKNOWN: { title: string; description: string };
}

export const paymentErrorTranslations: PaymentErrorTranslations = {
  ENTRY_FEE_PAYMENT_REQUIRED: {
    title: 'Payment Required',
    description: 'You need to complete the payment to join this tournament.',
  },
  ENTRY_FEE_PAYMENT_PENDING: {
    title: 'Payment Processing',
    description: 'Your payment is being processed. Please wait a moment.',
  },
  ENTRY_FEE_PAYMENT_EXPIRED: {
    title: 'Payment Expired',
    description: 'Your payment session has expired. Please start a new payment.',
  },
  ENTRY_FEE_PAYMENT_MISMATCH: {
    title: 'Payment Amount Mismatch',
    description: 'The payment amount does not match the required entry fee. Please contact support.',
  },
  PAYMENT_OWNER_MISMATCH: {
    title: 'Unauthorized Payment',
    description: 'This payment belongs to a different user. Please contact support if you believe this is an error.',
  },
  NETWORK_ERROR: {
    title: 'Connection Problem',
    description: 'Unable to connect to the payment service. Please check your internet connection and try again.',
  },
  TIMEOUT_ERROR: {
    title: 'Request Timeout',
    description: 'The request took too long to complete. Please try again.',
  },
  UNKNOWN: {
    title: 'Something Went Wrong',
    description: 'An unexpected error occurred. Please try again or contact support if the problem persists.',
  },
};
